import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { vehicleAPI } from '../utils/api';
import { toast } from 'react-toastify';
import './Vehicles.css';

const Vehicles = () => {
    const { language, t } = useLanguage();
    const [vehicles, setVehicles] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchVehicles();
    }, []);

    const fetchVehicles = async () => {
        try {
            const response = await vehicleAPI.getAll();
            setVehicles(response.data.data);
        } catch (error) {
            console.error('Error fetching vehicles:', error);
            toast.error(t('noVehicles'));
        } finally {
            setLoading(false);
        }
    };

    const getVehicleName = (vehicle) => {
        return vehicle[`name_${language}`] || vehicle.name_tr;
    };

    const getVehicleDescription = (vehicle) => {
        return vehicle[`description_${language}`] || vehicle.description_tr;
    };

    const getImageUrl = (imagePath) => {
        if (!imagePath) return null;

        // Eğer imagePath zaten tam URL ise, direkt kullan
        if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
            return imagePath;
        }

        const baseUrl = process.env.REACT_APP_API_URL?.replace('/api', '') || 'https://elittaksibodrum.com';

        // Eğer path /api ile başlamıyorsa, /api ekle
        if (!imagePath.startsWith('/api/')) {
            // /uploads/vehicles/... → /api/uploads/vehicles/...
            if (imagePath.startsWith('/uploads/')) {
                return `${baseUrl}/api${imagePath}`;
            }
            // Diğer durumlar için /api ekle
            return `${baseUrl}/api${imagePath}`;
        }

        // Zaten /api ile başlıyorsa, direkt ekle
        return `${baseUrl}${imagePath}`;
    };

    if (loading) {
        return (
            <div className="loading-container">
                <div className="loader"></div>
                <p>{t('loading')}...</p>
            </div>
        );
    }

    return (
        <div className="vehicles-page">
            <div className="container">
                <div className="page-header">
                    <h1 className="page-title">{t('availableVehicles')}</h1>
                    <p className="page-subtitle">
                        {t('selectVehicle')}
                    </p>
                </div>

                {vehicles.length === 0 ? (
                    <div className="no-vehicles">
                        <p>{t('noVehicles')}</p>
                    </div>
                ) : (
                    <div className="vehicles-grid">
                        {vehicles.map((vehicle) => (
                            <div key={vehicle.id} className="vehicle-card">
                                <div className="vehicle-image-container">
                                    {vehicle.images && vehicle.images.length > 0 ? (
                                        <img
                                            src={getImageUrl(vehicle.images[0])}
                                            alt={getVehicleName(vehicle)}
                                            className="vehicle-image"
                                            onError={(e) => {
                                                e.target.src = '/placeholder-vehicle.jpg';
                                            }}
                                        />
                                    ) : (
                                        <div className="vehicle-placeholder">
                                            <span className="placeholder-icon">🚕</span>
                                        </div>
                                    )}
                                </div>

                                <div className="vehicle-info">
                                    <h3 className="vehicle-name">
                                        {getVehicleName(vehicle)}
                                    </h3>

                                    <p className="vehicle-description">
                                        {getVehicleDescription(vehicle)?.substring(0, 100)}
                                        {getVehicleDescription(vehicle)?.length > 100 && '...'}
                                    </p>



                                    <div className="vehicle-actions">
                                        <Link
                                            to={`/vehicles/${vehicle.id}`}
                                            className="btn btn-outline"
                                        >
                                            {t('viewDetails')}
                                        </Link>
                                        <Link
                                            to={`/reservation?vehicle=${vehicle.id}`}
                                            className="btn btn-primary"
                                        >
                                            {t('bookNow')}
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Vehicles;